import React from "react";
import TransparentPage from "../components/TransparentPage";

const HomePage = () => {
  return (
    <div className="webcam">
      <TransparentPage />
    </div>
  );
};

export default HomePage;
